import { sva } from "@filadd/phi-plus-styled-system/css";
export const sectionMenuItemRecipe = sva({
    slots: ["root", "trigger", "parentItem", "content", "itemsContent"],
    base: {
        root: {
            width: "100%",
        },
        trigger: {
            width: "100%",
            px: 1,
        },
        content: {
            display: "flex",
            overflow: "hidden",
            px: 2,
        },
        parentItem: {
            width: "100%",
            display: "flex",
        },
        itemsContent: {
            width: "100%",
            mt: 1,
            pb: 1,
            display: "flex",
            flexDirection: "column",
            borderTop: "1px solid token(colors.primary.400)",
            borderBottom: "1px solid token(colors.primary.400)",
        },
    },
    variants: {
        hasScrollbar: {
            true: {
                trigger: {
                    px: 0,
                },
                content: {
                    px: 1,
                },
            },
            false: {},
        },
    },
});
//# sourceMappingURL=sectionMenuItemRecipe.js.map